import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { EditPage } from '../edit_page/EditPage';
import ProposalForm from '../proposal_form/ProposalForm';
import { Form } from '@ant-design/compatible';
import { getQuoteRestCrudThunksContractorId } from '../quote_utils/QuoteUtils';
import { withUserType } from '../withUserType';

const queryString = require('qs');

class EditWorkOrderProposalContractorPage extends React.Component<any, any> {
	state = {
		proposal: null,
		fetching: true,
	};

	componentDidMount() {
		const { match, getProposal } = this.props;
		const proposalId = match.params.proposalId;
		this.setState({ fetching: true });
		getProposal(proposalId).then((proposal) => {
			this.setState({ proposal, fetching: false });
		});
	}

	render() {
		const { history, userType, match } = this.props;
		const { proposal, fetching } = this.state;
		const workOrderId = match.params.id;

		return (
			<EditPage
				title="Edit Proposal"
				formComponentProps={{
					formData: {
						...proposal,
						workOrderId: workOrderId,
						isClientView: false,
					},
					onSuccess: (rec) => {
						history.push(`/${userType}/workOrders/detail/${workOrderId}/quotes`);
					},
				}}
				fetching={fetching}
				FormComponent={ProposalForm}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	proposal: state.proposals.detail,
	fetching: state.proposals.fetching,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getProposal: (id) =>
		dispatch(getQuoteRestCrudThunksContractorId(ownProps.userType, true, true).readOne(id)),
});

export default withRouter(
	withUserType(
		connect(mapStateToProps, mapDispatchToProps)(Form.create()(EditWorkOrderProposalContractorPage))
	)
);
